import MissionService from '../../service/mission';

const Action = {
    SET_MISSION: "SET_MISSION",
    SET_MISSION_PAGE_NUMBER: "SET_MISSION_PAGE_NUMBER",
    SET_MISSION_PAGE_SIZE: "SET_MISSION_PAGE_SIZE",
    SET_SELECTED_TAB_VALUE: "SET_SELECTED_TAB_VALUE",
    SET_SEARCH_TEXT_DATE: "SET_SEARCH_TEXT_DATE",
    GET_MISSION: "GET_MISSION",
    GET_MISSIONS: "GET_MISSIONS",
    GET_ARCHIVES: "GET_ARCHIVES",
    EXPORT_MISSION: "[MISSION] EXPORT MISSION",
    MODIFY_RESERVEDTIME: 'MODIFY_RESERVEDTIME',
    SET_NOTICE: "SET_NOTICE"
};

const ActionCreator = {
    setMission(mission) {
        return async (dispatch) => {
            try {
                dispatch({type: Action.SET_MISSION, mission});
                return mission;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    setMissionListPageNumber(listPageNumber) {
        return async (dispatch) => {
            try {
                dispatch({type: Action.SET_MISSION_PAGE_NUMBER, listPageNumber});
                return listPageNumber;
            } catch (error) {
                throw dispatch({error});
            }
        }
    },
    setMissionListPageSize(listPageSize) {
        return async (dispatch) => {
            try {
                dispatch({type: Action.SET_MISSION_PAGE_SIZE, listPageSize});
                return listPageSize;
            } catch (error) {
                throw dispatch({error});
            }
        }
    },
    setSelectedTabValue(selectedTabValue) {
        return async (dispatch) => {
            try {
                dispatch({type: Action.SET_SELECTED_TAB_VALUE, selectedTabValue});
                return selectedTabValue;
            } catch (error) {
                throw dispatch({error});
            }
        }
    },
    getMission(missionId) {
        return async (dispatch) => {
            try {
                const mission = await MissionService.findById(missionId);
                dispatch({type: Action.GET_MISSION, mission});
                return mission;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getInstitutionMission(missionId) {
        return async (dispatch) => {
            try {
                const mission = await MissionService.findByIdForInstitution(missionId);
                dispatch({type: Action.GET_MISSION, mission});
                return mission;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getMissions(params) {
        return async (dispatch) => {
            try {
                const { missions, numberOfRecords } = await MissionService.list(params)
                dispatch({type: Action.GET_MISSIONS, missions, numberOfRecords, params})
                return missions
            } catch (error) {
                throw dispatch({error})
            }
        };
    },
    refreshMissions() {
        return async (dispatch, getState) => {
            return await dispatch(ActionCreator.getMissions(getState().mission.lastGetMissionsParams))
        }
    },
    getMissionsForAdminMedical(params) {
        return async (dispatch) => {
            try {
                const { missions, numberOfRecords } = await MissionService.listForAdmin(params);
                dispatch({type: Action.GET_MISSIONS, missions, numberOfRecords, params})
                return missions;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getArchives(missionId) {
        return async (dispatch) => {
            try {
                const archives = await MissionService.getArchives(missionId);
                dispatch({type: Action.GET_ARCHIVES, archives});
                return archives;
            }  catch (error) {
                throw dispatch({error});
            }
        };
    },
    getArchivesByAdminMedical(missionId) {
        return async (dispatch) => {
            try {
                const archives = await MissionService.getArchivesByAdminMedical(missionId);
                dispatch({type: Action.GET_ARCHIVES, archives});
                return archives;
            }  catch (error) {
                throw dispatch({error});
            }
        };
    },
    openChatRoom(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.openChatRoom(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    openChatRoomByAdminMedical(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.openChatRoomByAdminMedical(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    fail(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.fail(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    failByAdminMedical(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.failByAdminMedical(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    finish(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.finish(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    finishByAdminMedical(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.finishByAdminMedical(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    cancel(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.cancel(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    cancelByAdminMedical(missionId) {
        return async (dispatch) => {
            try {
                return await MissionService.cancelByAdminMedical(missionId);
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    postNotice({id, medicalSuggest}) {
        return async (dispatch) => {
            try {
                const result = await MissionService.postNotice({id, medicalSuggest});
                dispatch({type: Action.SET_NOTICE, medicalSuggest: result });
                return result;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    postNoticeByAdminMedical({id, medicalSuggest}) {
        return async (dispatch) => {
            try {
                const result = await MissionService.postNoticeByAdminMedical({id, medicalSuggest});
                dispatch({type: Action.SET_NOTICE, medicalSuggest: result });
                return result;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    exportMission({identity, livingArea, missionType, missionStatus, dateFrom, dateTo}) {
        return async dispatch => {
            const events = await MissionService.exportMission({identity, livingArea, missionType, missionStatus, dateFrom, dateTo})
            dispatch({type: Action.EXPORT_MISSION, payload: events})
            return events
        }
    },
    exportMissionAdminMedical({identity, livingArea, missionType, missionStatus, dateFrom, dateTo}) {
        return async dispatch => {
            const events = await MissionService.exportMissionAdminMedical({identity, livingArea, missionType, missionStatus, dateFrom, dateTo})
            dispatch({type: Action.EXPORT_MISSION, payload: events})
            return events
        }
    },
    modifyReservationTime({reservationMissionId, date, startTime, endTime}) {
        return async dispatch => {
            const modifiedReservationTime = await MissionService.modifyReservationTime({
                reservationMissionId, date, startTime, endTime
            })
            dispatch({type: Action.MODIFY_RESERVEDTIME, modifiedReservationTime})
            return modifiedReservationTime
        }
    },
    modifyReservationTimeForAm({reservationMissionId, date, startTime, endTime}) {
        return async dispatch => {
            const modifiedReservationTime = await MissionService.modifyReservationTimeForAm({
                reservationMissionId, date, startTime, endTime
            })
            dispatch({type: Action.MODIFY_RESERVEDTIME, modifiedReservationTime})
            return modifiedReservationTime
        }
    },
};

const initialState = {
    list: [],
    temp: {},
    status: {},
    archives: [],
    listPageNumber: 0,
    listPageSize: 50,
    selectedTabValue: 0,
    numberOfRecords: 0,
    lastGetMissionsParams: {
        limit: 0,
        offset: 10,
        searchField: '',
        searchKeyword: '',
    },
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.SET_MISSION:
            return {
                ...state,
                temp: action.mission
            };
        case Action.GET_MISSION:
            return {
                ...state,
                ...action.mission
            };
        case Action.GET_MISSIONS:
            return {
                ...state,
                list: action.missions,
                numberOfRecords: action.numberOfRecords,
                lastGetMissionsParams: action.params,
            };
        case Action.SET_NOTICE:
            return {
                ...state,
                temp: {
                    ...state.temp,
                    medicalSuggest: action.medicalSuggest
                }
            };
        case Action.GET_ARCHIVES:
            return {
                ...state,
                archives: action.archives,
            };
        case Action.SET_MISSION_PAGE_NUMBER:
            return {
                ...state,
                listPageNumber: action.listPageNumber
            };
        case Action.SET_MISSION_PAGE_SIZE:
            return {
                ...state,
                listPageSize: action.listPageSize
            }
        case Action.SET_SELECTED_TAB_VALUE:
            return {
                ...state,
                selectedTabValue: action.selectedTabValue
            }
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/mission.js